<template>
  <!-- BSL-PENCERE P2: pencere kapalıyken sağ altta «Kurulum · N adım kaldı» + halka. Masaüstünde her
       sayfada; 640 px altında yalnız Anasayfa'da (FAB, alt eylem çubuğu ve gezinme ile çakışmasın). -->
  <Teleport to="body">
    <button v-if="goster" type="button" class="bsl-k-kok bsl-hap" :aria-label="metin" @click="ac">
      <svg class="bsl-hap-halka" viewBox="0 0 36 36" aria-hidden="true">
        <circle cx="18" cy="18" r="15" fill="none" stroke="var(--bsl-yuzey3)" stroke-width="4" />
        <circle cx="18" cy="18" r="15" fill="none" stroke="var(--bsl-vurgu)" stroke-width="4" stroke-linecap="round"
          :stroke-dasharray="CEVRE" :stroke-dashoffset="CEVRE * (1 - oran)" transform="rotate(-90 18 18)" />
      </svg>
      <span>{{ metin }}</span>
    </button>
  </Teleport>
</template>

<script>
import { bsl, durumYukle, gorunurMu, pencereAc } from "@/baslarken/durum";
import { hatAdimlari, yolunModulHatti } from "@/baslarken/hatlar";

const CEVRE = 2 * Math.PI * 15;
const TAZELE_MS = 15000;
const TAZELE_SURE_MS = 10 * 60 * 1000;

function depoOku(k) { try { return localStorage.getItem(k); } catch { return null; } }
function depoYaz(k, v) { try { localStorage.setItem(k, v); } catch { /* özel pencere */ } }

export default {
  name: "KurulumHapi",
  data() {
    return { bsl, CEVRE, mobil: window.innerWidth < 640 };
  },
  computed: {
    adimlar() {
      return gorunurMu() ? hatAdimlari(bsl.durum, "ANA") : [];
    },
    kalan() {
      return this.adimlar.filter((a) => !a.bitti).length;
    },
    oran() {
      return this.adimlar.length ? (this.adimlar.length - this.kalan) / this.adimlar.length : 0;
    },
    // BSL-D1 (B-1): iş seçilmemişse (SoruSor) kalan 0 olsa da hap kalır ve kutucuklara götürür.
    isSor() {
      return !!(bsl.durum && bsl.durum.SoruSor && !this.kalan);
    },
    metin() {
      return this.isSor ? "Kurulum · İşinizi seçin" : "Kurulum · " + this.kalan + " adım kaldı";
    },
    goster() {
      const d = bsl.durum;
      if (!d || d.Gizli || d.KartKapali || bsl.pencereAcik || bsl.turAktif || bsl.ornekMaddeKod || (!this.kalan && !d.SoruSor)) return false;
      const yol = this.$route.path;
      if (yol.startsWith("/sistem")) return false;
      return !this.mobil || yol === "/admin/main";
    },
  },
  watch: {
    "$route.path"(yol) {
      // BSL-D3 B-21: Anasayfa'ya dönüşte de tazelenir (başka sayfada biten iş hapa yansısın).
      if (bsl.bekleyenAdim || yol === "/admin/main") durumYukle(true);
      this.modulHattiDene(yol);
    },
    "bsl.durum"() {
      this.modulHattiDene(this.$route.path);
    },
    // «Göster» adımı sürerken aynı sayfada (pencere/dialog içinde) kaydedilen iş için durum arada tazelenir.
    "bsl.bekleyenAdim"(b) {
      clearInterval(this._tazele);
      if (!b) return;
      const bas = Date.now();
      this._tazele = setInterval(() => {
        if (!bsl.bekleyenAdim || Date.now() - bas > TAZELE_SURE_MS) return clearInterval(this._tazele);
        if (document.visibilityState === "visible") durumYukle(true);
      }, TAZELE_MS);
    },
  },
  mounted() {
    window.addEventListener("resize", this.boyut);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.boyut);
    clearInterval(this._tazele);
  },
  methods: {
    boyut() {
      this.mobil = window.innerWidth < 640;
    },
    ac() {
      pencereAc("ANA");
    },
    // P6: Teklif / Destek / Blog'a ilk girişte modül penceresi bir kez (tarayıcıda hatırlanır).
    modulHattiDene(yol) {
      const hat = yolunModulHatti(yol);
      const d = bsl.durum;
      if (!hat || !d || d.Gizli || d.KartKapali || d.KarsilamaGoster) return;
      if (bsl.pencereAcik || bsl.turIstegi || bsl.bekleyenAdim || bsl.ornekMaddeKod) return;
      const anahtar = "bsl-modul-" + hat;
      if (depoOku(anahtar)) return;
      if (!hatAdimlari(d, hat).some((a) => !a.bitti)) return;
      depoYaz(anahtar, "1");
      pencereAc(hat);
    },
  },
};
</script>

<style>
.bsl-hap {
  position: fixed;
  right: 20px;
  bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  z-index: 950;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--bsl-yuzey);
  color: var(--bsl-murekkep);
  border: 1px solid var(--bsl-cizgi);
  border-radius: 99px;
  padding: 7px 16px 7px 7px;
  box-shadow: var(--bsl-golge);
  font: inherit;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  animation: bslKYuksel 0.3s ease;
}
.bsl-hap:hover { border-color: var(--bsl-vurgu); }
.bsl-hap:focus-visible { outline: 2px solid var(--bsl-vurgu); outline-offset: 2px; }
.bsl-hap-halka { width: 34px; height: 34px; flex: none; }
@media (max-width: 640px) {
  .bsl-hap { right: 16px; bottom: calc(16px + env(safe-area-inset-bottom, 0px)); }
}
@media (prefers-reduced-motion: reduce) {
  .bsl-hap { animation: none; }
}
</style>
